var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.156,
    height: 40.486,
    viewBox: "0 0 49.156 40.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "camera_icon",
    d: "M938.882,889.682h33.152a8.016,8.016,0,0,0,8-7.983V862.311a8.016,8.016,0,0,0-8-7.983H967.8a2.306,2.306,0,0,1-1.886-.969l-.743-1.084a7.614,7.614,0,0,0-6.116-3.079h-7.2a7.613,7.613,0,0,0-6.116,3.079l-.8,1.084a2.47,2.47,0,0,1-1.886.969h-4.172a8.016,8.016,0,0,0-8,7.983V881.7a8.016,8.016,0,0,0,8,7.983Zm16.576-31.933a13.4,13.4,0,1,1-13.432,13.4A13.4,13.4,0,0,1,955.458,857.749Z",
    transform: "translate(-930.88 -849.195)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.13973bd3af3cc13fd65470164218dae8.svg";
export { ForwardRef as ReactComponent };